//------- cards
export const cardTypeLabels = {
  prepaid: 'balance',
  postpaid: 'limit',
};
//-------

//------- card actions
const transferOption = {
  label: 'move_to_another_member',
  value: 'transfer',
  icon: 'move-duo-vertical',
};

const freezeOption = {
  label: 'freeze',
  value: 'freeze',
  icon: 'freeze-select',
};

const blockOption = {
  label: 'block',
  value: 'block',
  icon: 'block',
};

export const changeRoleCardsSelect = [
  {
    label: 'move_to_another_member',
    value: 'move',
    icon: 'move-duo-vertical',
  },
  {
    label: 'keep_with_member',
    value: 'keep',
    icon: 'user-input',
  },
];

export const editTeamCardsSelect = [transferOption, blockOption];

export const freezeMemberCardsSelect = [
  transferOption,
  freezeOption,
  blockOption,
];

export const freezeLeadCardsSelect = [transferOption, blockOption];
//-------

//------- banks
export const currencySymbols = {
  USD: '$',
  EUR: '€',
  USDT: 'USDT',
};

export const MASTER_BANK_ID = 0;
export const REFERRAL_BANK_ID = 2;

export const binsLogo = {
  13: 'ee', // pulse
  12: 'ee', // flux
  7: 'ee', // prime
  14: 'ee', // strike
  15: 'ee', // vault
};
//-------

//------- teams
export const DEFAULT_TEAM_SLUG = 'default-team';
//-------
